import gql from "graphql-tag";

export const GET_ADMIN_BY_CONTEXT = gql`
  query {
    getAdminByContext {
      _id
    }
  }
`;
